<template>
    <header class="header">
        <div class="cabecario">
            <figure>
                <img src="/publico/img/logo-header.svg" alt="Logotipo Prefeitura" id="logopref">
            </figure>
            <div id="cabecario_borda"></div>
            <div id="cabecario_titulos">
                <h1 id="cabecario_titulo">Plataforma de Gerenciamento em Saúde</h1>
                <h2 class="mb-2" id="cabecario_subtitulo-hidden">SESAU - Campo Grande</h2>
                <h2 id="cabecario_subtitulo">{{sistema}}</h2>
            </div>
            <div id="dados_login">
                <div class="info_user ml-2">
                    <figure>
                        <img id="user_icon" src="/publico/img/icone_user.svg" alt="icone usuário">
                    </figure>
                    <span>Olá, {{ usuario }}</span>
                </div>
                <div class="info_user">
                    <figure>
                        <img id="unidade_icon" src="/publico/img/icone_hospital.svg" alt="ícone unidade">
                    </figure>
                    <span>{{ unidade }}</span>
                </div>
                <a href="/usuariopainel">PAINEL DO USUÁRIO</a>
            </div>
        </div>
        <div class="navegacao">
            <i aria-hidden="true" class="fa fa-bars burger" @click="navbarStatus = !navbarStatus"></i>
            <transition name="slide">
                <mobile-navbar 
                    v-if="navbarStatus"
                    @fechaNavbar="navbarStatus = false"
                />
            </transition>
            <main-navbar />
        </div>
    </header>
</template>

<script>
    import MobileNavbar from '../navbar/MobileNavbar.vue'
    import MainNavbar from '../navbar/MainNavbar.vue'
    export default {
        components: {
            MobileNavbar,
            MainNavbar
        },
        props: {
            sistema: {
                type: String
            },
            usuario: {
                type: String
            },
            unidade: {
                type: String
            }
        },
        data () {
            return {
                navbarStatus: false
            }
        },
        watch: {
            navbarStatus (value) {
                value == true ? 
                document.querySelector('html').classList.add('menu-ativo') :
                document.querySelector('html').classList.remove('menu-ativo');
            }
        }
    }
</script>

<style>
/* MOBILE FIRST */
.header {
    display: flex;
    flex-direction: column;
}
.cabecario {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: baseline;
    flex-wrap: nowrap;
    min-height: 135px;
    background-color: #255E8B;
}

.cabecario figure {
    display: none;
}

#logopref{
    width: 24rem;
}

#cabecario_borda {
    border-right: 1px solid #1b7296;
    height: 5.2rem;
    margin-right: 1.2rem;
    display: none;
}

#cabecario_titulos {
    align-self: flex-start;
    margin: 20px 10px 0 19px;
}

#cabecario_titulo {
    display: none;
    color: #1b7296;
    font-weight: 300;
    font-size: 2rem;
}

#cabecario_subtitulo {
    color: #ffffff;
    font-size: 1.3rem;
}


#cabecario_subtitulo-hidden {
    color: #ffffff;
    font-size: 1.4rem;
}

#dados_login {
    display: none;
    font-size: 0.9rem;
    font-weight: 300;
}

#user_icon {
    width: 1.2rem;
}

#unidade_icon {
    width: 1.8rem;
}

#dados_login a {
    color: red;
    font-size: 0.8rem;
    margin-left: 1.9rem;
    font-weight: bolder;
}

.info_user {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    margin-bottom: 0.2rem;
}

.navegacao {
    min-height: 38px;
    background-color: #f3f3f3;
    font-size: 2rem;
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.burger {
    margin-left: 1rem;
    display: block;
}
.main-nav {
    display: none;
}

@media (min-width: 768px) {
    .cabecario {
        background-color: #ffffff;
        justify-content: center;
    }
    .cabecario figure {
        display: inline-block;
    }
    #cabecario_borda {
        display: block;
    }
    #cabecario_titulos {
        flex-grow: 0.4;
        align-self: inherit;
        margin: 0;
    }
    #cabecario_titulo {
        display: block;
    }
    #cabecario_subtitulo-hidden {
        display: none;
    }
    #cabecario_subtitulo {
        color: #e25f5f;
        font-size: 1.8rem;
    }
    .burger {
        display: none!important;
    }
    .navegacao {
        background-color: #255E8B;
        font-size: 1rem;
        justify-content: center;
        align-items: stretch;
    }
    .main-nav {
        display: flex;
        align-items: center;
    }   
}


@media (min-width: 1120px) {
    #dados_login {
        display: flex;
        flex-direction: column;
    }
}

.slide-leave-active,
.slide-enter-active {
  transition: .6s;
}
.slide-enter {
  transform: translate(-100%, 0);
}
.slide-leave-to {
  transform: translate(-100%, 0);
}
</style>

